import 'ui-core/widgets/list-of-issues/js/loi';

(function () {
    'use strict';
    UX.loi.set.historyState = () => {};
    UX.loi.responsiveController = () => {};

    // Keyboard accessibility enhancements
    UX.loi.keyboard = {
        isInitialized: false,

        init: function () {
            if (this.isInitialized) {
                return;
            }

            this.setupTabNavigation();
            this.setupPanelNavigation();
            this.isInitialized = true;
        },

        setupTabNavigation: function () {
            $('.loi .tab__nav').each(function () {
                const $tabList = $(this);
                const $tabs = $tabList.find('a[role="tab"]');

                if ($tabs.length > 0 && !$tabList.data('keyboard-nav-initialized')) {
                    UX.loi.keyboard.attachTabListeners($tabList, $tabs);
                    $tabList.data('keyboard-nav-initialized', true);
                }
            });
        },

        attachTabListeners: function ($tabList, $tabs) {
            // Remove existing event listeners to prevent duplicates
            $tabList.off('keydown.keyboardNav focus.keyboardNav');
            $tabs.off('focus.keyboardNav click.keyboardNav');

            // Make the tab list focusable and set up keyboard navigation
            $tabList.attr('tabindex', '0');

            // Handle keyboard events on the tab list
            $tabList.on('keydown.keyboardNav', function (e) {
                const $activeTab = $tabs.filter('[tabindex="0"]');
                const activeIndex = $tabs.index($activeTab);

                switch (e.key) {
                    case 'ArrowLeft':
                    case 'ArrowRight':
                    case 'ArrowUp':
                    case 'ArrowDown':
                        e.preventDefault();
                        UX.loi.keyboard.navigateTabs(
                            e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1,
                            $tabs,
                            activeIndex
                        );
                        break;
                    case 'Tab':
                        // Allow default Tab behavior to move to next focusable element
                        break;
                    case 'Enter':
                    case ' ':
                        e.preventDefault();
                        $activeTab.trigger('click');
                        break;
                    case 'Home':
                        e.preventDefault();
                        UX.loi.keyboard.focusTab(0, $tabs);
                        UX.loi.keyboard.setActiveStates($tabs.eq(0), $tabs);
                        break;
                    case 'End':
                        e.preventDefault();
                        UX.loi.keyboard.focusTab($tabs.length - 1, $tabs);
                        UX.loi.keyboard.setActiveStates($tabs.eq($tabs.length - 1), $tabs);
                        break;
                }
            });

            // Handle focus events
            $tabList.on('focus.keyboardNav', function () {
                const $activeTab = $tabs.filter('[tabindex="0"]');
                if ($activeTab.length === 0) {
                    UX.loi.keyboard.focusTab(0, $tabs);
                }
            });

            // Handle individual tab focus
            $tabs.on('focus.keyboardNav', function () {
                const $this = $(this);
                if ($this.attr('tabindex') !== '0') {
                    $tabs.attr('tabindex', '-1');
                    $this.attr('tabindex', '0');
                }
            });

            // Handle tab clicks to update focus
            $tabs.on('click.keyboardNav', function () {
                const $this = $(this);
                $tabs.attr('tabindex', '-1');
                $this.attr('tabindex', '0');
            });

            // Initialize focus state
            const $activeTab = $tabs.filter('.active, [aria-selected="true"]').first();
            if ($activeTab.length > 0) {
                $activeTab.attr('tabindex', '0');
            } else {
                $tabs.first().attr('tabindex', '0');
            }

            $tabs.not('[tabindex="0"]').attr('tabindex', '-1');
        },

        navigateTabs: function (direction, $tabs, currentIndex) {
            let newIndex = currentIndex + direction;

            // Handle wrapping
            if (newIndex < 0) {
                newIndex = $tabs.length - 1;
            } else if (newIndex >= $tabs.length) {
                newIndex = 0;
            }

            this.focusTab(newIndex, $tabs);

            // Set active states and trigger click
            const $newTab = $tabs.eq(newIndex);
            if ($newTab.length > 0) {
                this.setActiveStates($newTab, $tabs);
            }
        },

        setActiveStates: function ($targetTab, $tabs) {
            if ($targetTab.length > 0) {
                // Remove active class from all parent li elements and all tab links
                $tabs.each(function () {
                    const $tab = $(this);
                    const $li = $tab.closest('li');
                    $li.removeClass('active');
                    $tab.removeClass('active').attr('aria-selected', 'false');
                });
                $targetTab.trigger('click');
                setTimeout(() => {
                    $targetTab.closest('li').addClass('active');
                }, 50);
            }
        },

        focusTab: function (index, $tabs) {
            const $targetTab = $tabs.eq(index);
            if ($targetTab.length > 0) {
                // Update tabindex attributes
                $tabs.attr('tabindex', '-1');
                $targetTab.attr('tabindex', '0');

                // Focus the tab
                $targetTab.focus();

                // Scroll into view if needed
                this.scrollTabIntoView($targetTab);
            }
        },

        scrollTabIntoView: function ($tab) {
            const $tabList = $tab.closest('.tab__nav');
            const $scrollContainer = $tabList.closest('.swipe__wrapper, .scroll');

            if ($scrollContainer.length > 0) {
                const tabOffset = $tab.position().left;
                const containerWidth = $scrollContainer.width();
                const tabWidth = $tab.outerWidth();
                const currentScroll = $scrollContainer.scrollLeft();

                // Check if tab is visible
                const isVisible = tabOffset >= 0 && tabOffset + tabWidth <= containerWidth;

                if (!isVisible) {
                    let scrollTo;
                    if (tabOffset < 0) {
                        // Tab is to the left, scroll to show it
                        scrollTo = currentScroll + tabOffset - 10;
                    } else {
                        // Tab is to the right, scroll to show it
                        scrollTo = currentScroll + (tabOffset + tabWidth - containerWidth) + 10;
                    }

                    $scrollContainer.animate(
                        {
                            scrollLeft: scrollTo,
                        },
                        300
                    );
                }
            }
        },

        setupPanelNavigation: function () {
            this.clearPanelEventListeners();

            const panels = this.getPanelSelectors();
            this.attachDecadePanelListeners(panels.decades);
            this.attachYearPanelListeners(panels.years, panels.decades);
            this.attachIssuePanelListeners(panels.issues);
        },

        clearPanelEventListeners: function () {
            $('.loi-tab-1 > .tab__nav, .loi-tab-2 .tab__nav, .issue-items').off('keydown.panelNav');
        },

        getPanelSelectors: function () {
            return {
                decades: $('.loi-tab-1 > .tab__nav'),
                years: $('.loi-tab-2 .tab__nav'),
                issues: $('.issue-items'),
            };
        },

        attachDecadePanelListeners: function ($decadePanels) {
            $decadePanels.on('keydown.panelNav', e => {
                if (this.isTabForward(e)) {
                    this.navigateToYearPanel(e, $(e.target));
                }
            });
        },

        attachYearPanelListeners: function ($yearPanels, $decadePanels) {
            $yearPanels.on('keydown.panelNav', e => {
                if (this.isTabForward(e)) {
                    this.navigateToIssuePanel(e, $(e.target));
                } else if (this.isTabBackward(e)) {
                    this.navigateToDecadePanel(e, $decadePanels);
                }
            });
        },

        attachIssuePanelListeners: function ($issuePanels) {
            $issuePanels.on('keydown.panelNav', e => {
                if (this.isTabBackward(e)) {
                    this.navigateToYearPanelFromIssues(e, $(e.target));
                }
            });
        },

        isTabForward: function (e) {
            return e.key === 'Tab' && !e.shiftKey;
        },

        isTabBackward: function (e) {
            return e.key === 'Tab' && e.shiftKey;
        },

        navigateToYearPanel: function (e, $currentPanel) {
            const $activeTab = $currentPanel.find('a[tabindex="0"]');
            if (!$activeTab.length) return;

            const targetPane = $activeTab.data('target');
            if (!targetPane) return;

            const $yearPanel = $(targetPane).find('.tab__nav');
            if ($yearPanel.length) {
                e.preventDefault();
                this.focusFirstTab($yearPanel);
            }
        },

        navigateToIssuePanel: function (e, $currentPanel) {
            const $activeTab = $currentPanel.find('a[tabindex="0"]');
            if (!$activeTab.length) return;

            const targetPane = $activeTab.data('target');
            if (!targetPane) return;

            const $issuePanel = $(targetPane).find('.issue-items');
            if ($issuePanel.length) {
                e.preventDefault();
                this.focusFirstIssue($issuePanel);
            }
        },

        navigateToDecadePanel: function (e, $decadePanels) {
            e.preventDefault();
            const $activeDecade = $decadePanels.find('a[aria-selected="true"]');
            if ($activeDecade.length) {
                $activeDecade.focus();
            }
        },

        navigateToYearPanelFromIssues: function (e, $currentPanel) {
            e.preventDefault();
            const $parentYearPanel = $currentPanel.closest('.loi-tab-2').find('.tab__nav');
            if (!$parentYearPanel.length) return;

            const $activeYear = $parentYearPanel.find('a[tabindex="0"]');
            if ($activeYear.length) {
                $activeYear.focus();
            } else {
                this.focusFirstTab($parentYearPanel);
            }
        },

        focusFirstTab: function ($panel) {
            setTimeout(() => {
                const $firstTab = $panel.find('a').first();
                if ($firstTab.length) {
                    $firstTab.attr('tabindex', '0').focus();
                }
            }, 50);
        },

        focusFirstIssue: function ($issuePanel) {
            setTimeout(() => {
                const $firstIssue = $issuePanel.find('a').first();
                if ($firstIssue.length) {
                    $firstIssue.focus();
                }
            }, 50);
        },
    };

    // Initialize keyboard navigation when DOM is ready
    $(document).ready(function () {
        UX.loi.keyboard.init();
    });

    // Re-initialize when new content is loaded via AJAX
    const originalAjaxResponse = UX.loi.ajaxResponse;
    UX.loi.ajaxResponse = function () {
        if (originalAjaxResponse) {
            originalAjaxResponse.call(this);
        }
        // Re-initialize keyboard navigation for new content
        setTimeout(() => {
            UX.loi.keyboard.setupTabNavigation();
            UX.loi.keyboard.setupPanelNavigation();
        }, 100);
    };
})();
